module.exports = __webpack_public_path__ + "static/img/product.8b636e17.svg";